module.exports = __webpack_public_path__ + "img/sjsl.199351cd.png";